<template>
  <user-course-register>
    <template v-slot:step1>
      <h5>Informações iniciais</h5>
      <p class="mb-2">Capriche na apresentação do produto, pois será um diferencial na momento da venda ; ) <span
        @click="modelPageExample = true">Ver modelo de exemplo</span>
      </p>
      <v-card flat>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12">
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>

                  <v-col cols="12" sm="12" class="pb-0">
                    <v-text-field
                      label="Título"
                      outlined
                      color="blue"
                      v-model="course.title"
                      :rules="rules.course.title"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" class="pb-0">
                    <v-text-field
                      outlined
                      v-model="course.summary"
                      label="Resumo"
                      required
                      color="blue"
                      :rules="rules.course.summary"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" class="pb-0">
                    <v-textarea
                      outlined
                      v-model="course.description"
                      label="Descrição"
                      color="blue"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" class="pb-0" v-if="loadingCategories">
                    <v-progress-linear indeterminate></v-progress-linear>
                  </v-col>

                  <v-col cols="12" sm="12" class="pb-0" v-else>
                    <h6>Categorias do curso</h6>
                    <p>As categorias ajudam seu curso ser exibido nos filtros da busca. Selecione até 3 categorias que
                      seu
                      produto se encaixe.</p>

                    <div class="categories-chips mb-0">
                      <v-chip
                        v-for="(category, $index) in categories"
                        class="categories-chips-item"
                        :color="categoryColor(category._id)"
                        outlined
                        :key="`cat${$index}`"
                        @click="selectCategory(category._id)"
                      >
                        {{ category.name }}
                      </v-chip>

                      <!--
                                            <span v-for="(category, $index) in categories" class="categories-chips-item"
                                                  :id="`cat${category._id}`"
                                                  @click="categoriesActive($event, category._id)" :key="`cat${$index}`">{{
                                                category.name
                                              }}</span>
                      -->
                      <br/>
                      <div class="categories-chips-alert" v-if="categoriesAlert">{{ categoriesAlert }}
                        <v-icon @click="categoriesAlert = !categoriesAlert">close</v-icon>
                      </div>
                    </div>
                  </v-col>

                  <div class="divisor-app mt-5 mb-5"></div>

                  <v-col cols="12" sm="12" class="pb-0">
                    <h6>Certificado do curso</h6>
                    <p>Selecione se o curso terá emissão de certificado, e se esse certificado será emitido manualmente para os usuário que o concluírem.</p>

                    <v-switch v-model="course.hasCertificate"
                              :label="(course.hasCertificate ? 'Tem certificado' : 'Não tem certificado')"></v-switch>

                    <v-switch v-model="course.manualCertificate" v-if="course.hasCertificate"
                              :label="(course.manualCertificate ? 'Liberação manual do certificado' : 'Certificado liberado automaticamente')"></v-switch>
                  </v-col>

                  <div class="divisor-app mt-5 mb-5"></div>

                  <v-col cols="12" sm="12" md="12">
                    <h6>Data de início e carga horária</h6>
                    <p>informe uma data para deixar seu curso disponível e a carga horária total do curso.</p>
                  </v-col>

                  <v-col cols="12" sm="12" md="3">
                    <v-text-field v-model="course.workload" outlined label="Carga Horária"
                                  placeholder="Informe a quantidade de horas" color="blue" v-mask="'####'" required
                                  :rules="rules.course.workload">
                      <template v-slot:append>
                        <span style="margin-top: 3px; display: block;">horas</span>
                      </template>
                    </v-text-field>
                  </v-col>

                  <!-- <v-col cols="12" sm="12" md="6">
                    <v-select
                      outlined
                      v-model="course.gradeTypes"
                      label="Séries"
                      :items="gradeTypes"
                      item-value="_id"
                      item-text="name"
                      multiple />
                  </v-col> -->

                  <v-col cols="12" sm="12" md="3">
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          outlined
                          v-model="dateFormatted"
                          label="Data de início"
                          @blur="startAt = parseDate(dateFormatted)"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="startAt" no-title @input="menu1 = false" locale="pt-br"></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="12" class="pt-0">
                    <v-switch class="mt-0" v-model="course.isPublic"
                              :label="(course.isPublic ? 'Curso Público' : 'Curso Pago')"></v-switch>
                  </v-col>
                  <v-col cols="12" sm="12" md="3" v-if="!course.isPublic">
                    <!--
                                        <v-text-field v-model="course.price" outlined label="Valor do curso"
                                                      placeholder="Informe o valor do curso" color="blue" v-mask="maskPrice">
                                        </v-text-field>
                    -->
                    <v-text-field v-model.lazy="course.price" outlined label="Valor do curso"
                                  placeholder="Informe o valor do curso" color="blue" v-money="money">
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="9" v-if="!course.isPublic">
                    <v-radio-group v-model="course.passOnTax" row>
                      <v-radio label="Repassar taxas para o usuário" :value="true"></v-radio>
                      <v-radio label="Arcar com as taxas" :value="false"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <div class="divisor-app mt-5 mb-5"></div>

                  <v-col cols="12" md="12" class="img-course-register">
                    <h5>Imagens de apresentação</h5>
                    <p>Aqui vamos cadastrar a imagem de capa e thumb do seu curso.</p>
                  </v-col>

                  <v-col cols="12" md="4" class="thumb-register">
                    <h6>Imagem da thumb do curso</h6>
                    <div class="thumb-register-img"
                         :style="!image ? '' : { backgroundImage: 'url(' + image + ')' }"
                         @click="onButtonClick('uploaderThumb')">
                      <span>{{ uploadThumbText }}</span>
                    </div>
                    <p>Dimensões ideais: 260x192pixels</p>
                    <input
                      ref="uploaderThumb"
                      class="d-none"
                      type="file"
                      accept="image/*"
                      @change="imageFileChanged($event)"
                    >
                    <v-icon v-if="fileImage" @click="removeFileImage">delete</v-icon>
                  </v-col>

                  <v-col cols="12" md="8" class="capa-register">
                    <h6>Imagem de capa do curso</h6>
                    <div class="capa-register-img"
                         :style="!cover ? '' : { backgroundImage: 'url(' + cover + ')' }"
                         @click="onButtonClick('uploaderCapa')">
                      <span>{{ uploadCapaText }}</span>
                    </div>
                    <p>Dimensões ideais: 1180x230pixels</p>
                    <input
                      ref="uploaderCapa"
                      class="d-none"
                      type="file"
                      accept="image/*"
                      @change="coverFileChanged($event)"
                    >
                    <v-icon v-if="fileCover" @click.prevent="removeFileCover">delete</v-icon>
                  </v-col>

                  <div class="divisor-app mt-5 mb-5"></div>

                  <v-col cols="12" class="img-course-register">
                    <h5>Vídeo de apresentação</h5>
                    <p>Publique um vídeo explicativo de seu curso.</p>
                  </v-col>

                  <v-col cols="12" md="12" class="video-intro">
                    <div class="clearfix mb-2">
                      <upload-btn :title="(course.videoIntro ? 'Atualizar vídeo' : 'Subir vídeo')"
                                  class="white-text float-left"
                                  @file-update="changeVideoIntro"
                                  accept="video/*"
                                  :uniqueId="true">
                      </upload-btn>
                      <upload-btn :title="(course.videoIntro && course.videoIntro.vimeoId) ? 'Atualizar imagem do vídeo' : 'Cadastrar imagem do vídeo'"
                                  class="white-text float-left"
                                  @file-update="changeVideoIntroThumb"
                                  accept="image/*"
                                  :uniqueId="true">
                      </upload-btn>
                    </div>
                    <v-alert type="info" v-if="course.videoIntro && course.videoIntro.vimeoStatus === 'in_progress'">
                      O vídeo está sendo processado pelo Vimeo
                    </v-alert>
                    <div
                      id="player"
                      ref="player"
                    />
                    <v-btn color="error" v-if="course.videoIntro && course.videoIntro.vimeoId"
                           @click="doRemoveVideoIntro">Remover o vídeo de introdução
                    </v-btn>
                  </v-col>

                  <!-- <v-col xs="12" sm="6" md="4" lg="3" v-if="course.image" class="img-course">
                    <v-img :src="course.image" aspect-ratio="2" />
                  </v-col>

                  <v-col xs="12" sm="6" md="8" lg="9">
                    <v-file-input multiple label="File input" :fileChangedCallback="fileChanged" :ripple="false" accept="image/*"></v-file-input>
                    <upload-btn class="pl-0" title="Selecionar Imagem" :fileChangedCallback="fileChanged" :ripple="false" accept="image/*" :loading="true" />
                    <v-btn v-if="course.image" dark color="red" @click="deleteImage">Excluir Imagem</v-btn>
                    <v-col sm="12" class="info-image" v-if="!course.image">
                      Melhor resolução: 260x180px
                    </v-col>
                  </v-col> -->

                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="green" dark @click="saveCourse" class="mt-3 ml-0" :disable="sending" :loading="sending">
            Avançar
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-row v-if="showProgress">
        <v-col cols="12">
          {{ messageProgress }}
          <v-progress-linear color="blue" height="10" :value="uploadProgress"></v-progress-linear>
        </v-col>
      </v-row>
      <v-dialog
        v-model="modelPageExample"
        max-width="800"
      >
        <v-card class="modal-img">
          <v-img src="@/assets/pagina-exemplo.png"></v-img>
        </v-card>
      </v-dialog>
    </template>
  </user-course-register>
</template>
<script>
import UploadButton from 'vuetify-upload-button'
import Player from '@vimeo/player'
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
import { maska } from 'maska'
import UserCourseRegister from '@/views/User/CourseRegister'
import { numberFormat } from '@/helpers'

export default {
  name: 'UserCourseRegisterStep1',
  components: {
    UserCourseRegister,
    'upload-btn': UploadButton
  },
  directives: { mask, money: VMoney, maska },
  data: vm => ({
    isConnected: false,
    startAt: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      precision: 2,
      masked: false
    },
    menu1: false,
    sending: false,
    loadingCategories: false,
    showProgress: false,
    uploadProgress: 0,
    messageProgress: '',
    removeImage: false,
    removeCover: false,
    removeVideoIntro: false,
    gradeTypes: [],
    valid: false,
    fileImage: null,
    fileCover: null,
    fileVideoIntro: null,
    fileVideoIntroThumb: null,
    modelPageExample: false,
    image: null,
    cover: null,
    course: {
      _id: null,
      gradeTypes: [],
      categories: [],
      startAt: null,
      price: 123,
      title: '',
      isPublic: true,
      hasCertificate: true,
      manualCertificate: false,
      passOnTax: false,
      summary: '',
      description: '',
      image: '',
      cover: '',
      workload: null,
      videoIntro: null,
    },
    thumbSelectedFile: null,
    capaSelectedFile: null,
    isSelecting: false,
    categories: [],
    categoriesList: [
      { categoria: 'Robótica' },
      { categoria: 'Marketing' },
      { categoria: 'Desenvolvimento' },
      { categoria: 'Finanças' },
      { categoria: 'Culinária e Gastronomia' },
      { categoria: 'Design' },
      { categoria: 'Programação' }
    ],
    categoriesListSelected: [],
    categoriesAlert: '',
    rules: {
      course: {
        title: [
          v => !!v || 'Preencha o título do curso'
        ],
        summary: [
          v => !!v || 'Preencha o resumo do curso'
        ],
        workload: [
          v => !!v || 'Preencha a carga horária do curso'
        ]
      }
    }
  }),
  sockets: {
    connect () {
      // Fired when the socket connects.
      this.isConnected = true
    },
    disconnect () {
      this.isConnected = false
    },
    socketProgressVimeo (data) {
      this.messageProgress = 'Subindo vídeo para o Vimeo'
      this.uploadProgress = parseFloat(data.value)

      // if (data.value >= 100) {
      //   this.$router.push({ name: 'course-create-step2', params: { courseId: this.course._id } })
      // }
    }
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.startAt)
    },
    uploadThumbText () {
      return this.thumbSelectedFile ? 'Trocar imagem' : 'Selecionar imagem'
    },
    uploadCapaText () {
      return this.capaSelectedFile ? 'Trocar imagem' : 'Selecionar imagem'
    }
  },
  watch: {
    startAt (val) {
      this.dateFormatted = this.formatDate(val)
    },
    'course.startAt' (val) {
      if (val) {
        const date = new Date(val)

        this.startAt = date.toISOString().substr(0, 10)
      }
    },
    'course.categories' (val) {
      if (val && val.length > 3) {
        this.categoriesAlert = 'Máximo 3 categorias'

        this.course.categories.pop()
      }
    }
  },
  created () {
    this.getCategories()
    if (this.$route.params.courseId) {
      this.getCourse(this.$route.params.courseId)
    }
  },
  methods: {
    doRemoveVideoIntro () {
      this.removeVideoIntro = true
      this.course.videoIntro = null
    },
    changeVideoIntro (file) {
      this.fileVideoIntro = file
    },
    changeVideoIntroThumb (file) {
      this.fileVideoIntroThumb = file
    },
    selectCategory (categoryId) {
      const index = this.course.categories.findIndex(catId => catId === categoryId)

      if (index === -1) {
        this.course.categories.push(categoryId)
      } else {
        this.course.categories.splice(index, 1)
      }
    },
    categoryColor (categoryId) {
      let color = 'grey'

      const index = this.course.categories.findIndex(cId => cId === categoryId)

      if (index !== -1) {
        color = 'indigo'
      }

      return color
    },
    getCategories () {
      this.loadingCategories = true

      this.axios('/public/categories/combo').then(({ data }) => {
        if (data.success) {
          this.categories = data.categories
        }
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        this.loadingCategories = false
      })
    },
    getCourse (courseId) {
      this.axios.get(`/user/course/info/${courseId}`).then(response => {
        if (response.data.success) {
          this.course = response.data.course

          if (this.course.image) {
            this.image = this.course.image
          }

          if (this.course.cover) {
            this.cover = this.course.cover
          }

          if (response.data.course.price) {
            this.course.price = numberFormat(response.data.course.price, 2, ',', '.')
          }

          if (this.course.videoIntro && this.course.videoIntro.vimeoId) {
            if (this.course.videoIntro.vimeoStatus === 'complete') {
              new Player('player', {
                id: this.course.videoIntro.vimeoId
              })
            }
          }
        }
      }).catch(err => {
        console.error(err)
      })
    },
    removeFileImage () {
      this.removeImage = true
      this.fileImage = null
      this.course.image = null
    },
    removeFileCover () {
      this.removeCover = true
      this.fileCover = null
      this.course.cover = null
    },
    onButtonClick (type) {
      this.isSelecting = true
      window.addEventListener('focus', () => {
        this.isSelecting = false
      }, { once: true })

      this.$refs[type].click()
    },
    imageFileChanged (e) {
      this.fileImage = e.target.files[0]

      const reader = new FileReader()
      reader.onload = (e) => {
        this.image = e.target.result
      }
      reader.readAsDataURL(this.fileImage)
    },
    coverFileChanged (e) {
      this.fileCover = e.target.files[0]

      const reader = new FileReader()
      reader.onload = (e) => {
        this.cover = e.target.result
      }
      reader.readAsDataURL(this.fileCover)
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    validate () {
      return !!this.$refs.form.validate()
    },
    // getGradeTypes() {
    //   this.axios.get('/grade-types/combo').then(({data}) => {
    //     if (data.success) {
    //       this.gradeTypes = data.combo
    //     }
    //   })
    // },
    saveCourse () {
      const formData = new FormData()

      if (this.startAt) {
        formData.append('startAt', new Date(new Date(this.startAt).toLocaleString('en-US', { timeZone: 'UTC' })).toISOString())
      }

      if (this.course.title) {
        formData.append('title', this.course.title)
      }

      if (this.course.isPublic) {
        formData.append('isPublic', 'true')
      } else {
        formData.append('isPublic', 'false')

        formData.append('price', this.course.price.replace('R$ ', '').replace(/\./g, '').replace(',', '.'))
        formData.append('passOnTax', this.course.passOnTax)
      }

      if (this.course.hasCertificate) {
        formData.append('hasCertificate', 'true')
      } else {
        formData.append('hasCertificate', 'false')
      }

      if (this.course.manualCertificate) {
        formData.append('manualCertificate', 'true')
      } else {
        formData.append('manualCertificate', 'false')
      }

      if (this.course.summary) {
        formData.append('summary', this.course.summary)
      }

      if (this.course.description) {
        formData.append('description', this.course.description)
      }

      if (this.course.workload) {
        formData.append('workload', this.course.workload)
      }

      if (this.removeImage) {
        formData.append('removeImage', this.removeImage)
      }

      if (this.removeCover) {
        formData.append('removeCover', this.removeCover)
      }

      if (this.removeVideoIntro) {
        formData.append('removeVideoIntro', this.removeVideoIntro)
      }

      if (this.course.gradeTypes && this.course.gradeTypes.length) {
        for (const gradeType of this.course.gradeTypes) {
          formData.append('gradeTypes', gradeType)
        }
      }

      if (this.course.categories && this.course.categories.length) {
        for (const categoryId of this.course.categories) {
          formData.append('categories', categoryId)
        }
      }

      if (this.course._id) {
        formData.append('_id', this.course._id)
      }
      if (this.fileImage) {
        formData.append('image', this.fileImage)
      }

      if (this.fileCover) {
        formData.append('cover', this.fileCover)
      }

      if (this.fileVideoIntro) {
        formData.append('videoIntro', this.fileVideoIntro)
      }

      if (this.fileVideoIntroThumb) {
        formData.append('videoIntroThumb', this.fileVideoIntroThumb)
      }

      if (this.validate()) {
        this.sending = true
        this.showProgress = true
        this.messageProgress = 'Salvando dados do curso'

        let request = this.axios.post

        if (this.course._id) {
          request = this.axios.put
        }

        request('/user/course/step1', formData, {
          onUploadProgress: progressEvent => {
            this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          }
        }).then(({ data }) => {
          if (data.success) {
            this.$router.push({ name: 'course-create-step2', params: { courseId: data.course._id } })
          }
        }).catch(err => {
          console.error(err)
          this.$swal(
            'Ops',
            'Houve um erro ao cadastrar o curso',
            'error'
          )
        }).finally(() => {
          this.sending = false
          this.showProgress = false
        })
      }
    }
  }
}
</script>

<style scoped>
.v-chip {
  border-width: 3px;
}
</style>
